export { default as CustomSlide } from './custom-slide';
